<template>
<div class="bo-user-list-main">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>{{ subtitle }}</small><br>
        {{ title }}
      </h1>
      <hr>
    </div>
  </div>
  <sui-table :columns="table.columns"
            :actions="table.actions"
            :keyfield="table.keyfield"
            :list="all"
            :filterGen="filters"
            :title="title"
            :filter="filter"
            :filterVariables="filterVariables"
            ref="table"
            @remove="askForRemoval($event)"
            @update="updateUser($event)"
            @info="getUserInfo($event)"
            @password="askForPassword($event)">
    <template slot="actions">
      <btn type="warning" @click="exportList" class="form-group">
        Export csv
      </btn>
    </template>
  </sui-table>
  <modal v-model="removeModal"
         @hide="removeModalEnded"
         title="Confirmation"
         ok-text="Oui" cancel-text="Non"
         ok-type="danger" cancel-type="primary">
    <p v-if="removeModal">
      Êtes vous certain.e de vouloir supprimer l'utilisateur
      {{ user.firstName }} {{ user.name }} ?
    </p>
  </modal>
  <modal v-model="passwordModal"
         @hide="passwordModalEnded"
         title="Confirmation"
         ok-text="Oui" cancel-text="Non"
         ok-type="danger" cancel-type="primary">
    <div v-if="passwordModal">
      <p v-if="isGhost">
        Êtes vous certain.e de vouloir ouvrir le compte de l'utilisateur
        {{ user.firstName }} {{ user.name }} ?
      </p>
      <p v-else>
        Êtes vous certain.e de vouloir réinitialiser le mot de passe l'utilisateur
        {{ user.firstName }} {{ user.name }} ?
      </p>
    </div>
  </modal>
  <user-modal :user="userInfoTarget" :storePrefix="storePrefix"
              v-model="userInfoTrigger"></user-modal>
  <modal v-model="updateUserModal"
         title="Edition"
         :header="false"
         :footer="false">
    <bo-add-user v-if="updateUserModal"
                  title="Edition d'un utilisateur SPIADI"
                  action="update"
                  userCss="col-xs-offset-3 col-xs-6 col-sm-offset-2
                col-sm-8"
                  @end-edit-user="closeUpdateUserModal($event)"
                  :user="user"
                  :routePrefix="routePrefix"
                  :storePrefix="storePrefix"></bo-add-user>
  </modal>
</div>
</template>

<script>
import stringify from 'csv-stringify'

import suiTable from '@/sui/components/table'
import boAddUser from '@/components/boadduser'
import userModal from '@/components/usermodal'
import filters from '@/tools/users/filters'
import saveBlob from '@/sui/components/saveblob'

export default {
  name: 'bo-user-list',

  props: {
    parentAll: Array,
    title: String,
    subtitle: String,
    storePrefix: String,
    keepLast: true,
    routePrefix: String
  },

  data () {
    const cl = 'table-column-filter'
    const col = (e, f) => `${e} <span class='${cl}'>(${f})</span>`
    return {
      filter: '',
      filterVariables: [
        { key: 'id', field: 'id', name: 'ID utilisateur' },
        { key: 'n', field: 'name', name: 'Nom' },
        { key: 'p', field: 'firstName', name: 'Prénom' },
        { key: 'e', field: 'emails', name: 'E-mails' },
        { key: 'r', field: 'roles', name: 'Roles' }
      ],
      user: null,
      userInfoTarget: null,
      userInfoTrigger: false,
      removeModal: false,
      passwordModal: false,
      updateUserModal: false,
      csv: {
        target: null
      },
      table: {
        columns: [
          {
            html: col('Nom', '$n'),
            field: 'name'
          },
          {
            html: col('Prénom', '$p'),
            field: 'firstName'
          },
          {
            html: col('Emails', '$e'),
            field: 'emails'
          },
          {
            html: col('Rôles', '$r'),
            field: 'roles'
          }
        ],
        actions: [
          {
            event: 'remove',
            name: 'Supprimer'
          },
          {
            event: 'update',
            name: 'Editer'
          },
          {
            event: 'password',
            name: 'Mot de passe'
          },
          {
            event: 'info',
            name: 'Détails'
          }
        ],
        keyfield: 'id'
      }
    }
  },

  computed: {
    isGhost () {
      return this.user != null && this.user.roles.includes('ghost')
    },

    all: function () {
      const reducer = (result, u) => {
        result.push(
          {
            source: u,
            name: u.name,
            firstName: u.firstName,
            emails: u.email,
            roles: u.roles,
            id: u.id,
            filterlabel: `${u.name} ${u.firstName} ${u.email} ${u.id}`
          }
        )
        return result
      }
      return this.parentAll.reduce(reducer, [])
    },

    filters: function () {
      return filters
    }
  },

  methods: {
    askForRemoval: function (u) {
      this.removeModal = true
      this.user = u
    },

    removeModalEnded: function (msg) {
      if (msg === 'ok') {
        this.remove(this.user.id)
      }
      this.user = null
    },

    remove: function (id) {
      if (this.keepLast && this.all.length === 1) {
        this.$notify({
          type: 'danger',
          title: 'Attention !',
          duration: 0,
          content: 'Impossible de supprimer le dernier utilisateur.'
        })
        return
      }

      const vm = this
      this.$store.dispatch(`${this.storePrefix}/remove`, { i: id }).then(
        (response) => {
          if (response.data.err == null) {
            vm.$notify({
              type: 'success',
              title: 'Succès !',
              content: `Utilisateur ${id} supprimé avec succès.`
            })
            vm.$store.dispatch(`${this.storePrefix}/all`)
          } else {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Impossible de supprimer l'utilisateur ${id}: ${response.data.err}.`
            })
          }
        }).catch(function (e) {
        vm.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Impossible de supprimer l'utilisateur ${id}: ${e}.`
        })
      })
    },

    getUserInfo: function (u) {
      this.userInfoTarget = u.source
      this.userInfoTrigger = true
    },

    updateUser: function (u) {
      this.user = u.source
      this.updateUserModal = true
    },

    closeUpdateUserModal: function (event) {
      this.user = null
      this.updateUserModal = false
      this.$store.dispatch(`${this.storePrefix}/all`)
    },

    askForPassword: function (u) {
      this.passwordModal = true
      this.user = u.source
    },

    passwordModalEnded: function (msg) {
      if (msg === 'ok') {
        this.initPassword(this.user.name, this.user.firstName, this.user.email)
      }
      this.user = null
    },

    initPassword: function (name, firstName, email) {
      let instance = this
      let em = email[0]
      const request = {
        name: name,
        firstName: firstName,
        email: em,
        source: this.isGhost,
        prefix: this.routePrefix
      }
      this.$store.dispatch(`password/init`, request).then(
        (response) => {
          if (response.data.err == null) {
            instance.$notify({
              type: 'success',
              title: 'Succès !',
              content: `La demande de réinitialisation 
              du mot de passe de l'utilisateur ${email} est effectuée.`
            })
            instance.$store.dispatch(`${this.storePrefix}/all`)
          } else {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Impossible de réinitialiser le mot de passe de 
              l'utilisateur ${email}: ${response.data.err}.`
            })
          }
        }).catch(function (e) {
        instance.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Impossible de réinitialiser le mot de passe de 
              l'utilisateur ${email}: ${e}.`
        })
      })
    },

    exportList: function (e) {
      const instance = this
      stringify(
        this.$refs.table.formattedList,
        {
          header: true,
          delimiter: ';',
          bom: true,
          cast: {
            boolean: function (b) {
              return { value: b ? 'Oui' : 'Non', quote: false }
            },
            object: function (v, ctx) {
              if (ctx.column !== 'emails' &&
                  ctx.column !== 'roles') {
                return JSON.Stringify(v)
              }

              const count = v.length
              if (count === 0) {
                return ''
              }

              let result = v[0]
              for (let i = 1; i !== count; ++i) {
                result = `${result}, ${v[i]}`
              }
              return result
            }

          },
          columns: [
            { key: 'name', header: 'Nom' },
            { key: 'firstName', header: 'Prénom' },
            { key: 'emails', header: 'Adresses e-mail' },
            { key: 'roles', header: 'Roles' }
          ]
        },

        function (err, output) {
          if (err != null) {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                instance.csv.target = {
                  filename: `bo-export-users.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    }
  },

  components: {
    'sui-table': suiTable,
    'bo-add-user': boAddUser,
    'user-modal': userModal,
    'save-blob': saveBlob
  }
}
</script>

<style scoped lang="less">
</style>
